import { styled, SxProps } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

const variantDictionary = {
  primary: {
    color: colors.white,
    backgroundColor: colors.brandBlue500,
  },
  "primary-inverse": {
    color: colors.brandBlue500,
    backgroundColor: colors.white,
  },
  gray: {
    color: colors.white,
    backgroundColor: colors.gray500,
  },
  "light-gray": {
    color: colors.gray600,
    backgroundColor: colors.gray100,
  },
};

export interface BadgeProps {
  paddingRight?: string;
  paddingLeft?: string;
  paddingTop?: string;
  paddingBottom?: string;
  variant?: keyof typeof variantDictionary;
  color?: string;
  backgroundColor?: string;
  style?: React.CSSProperties;
  sx?: SxProps;
}

export const Badge = styled("div", {
  shouldForwardProp(propName) {
    return (
      propName !== "color" &&
      propName !== "backgroundColor" &&
      propName !== "variant" &&
      propName !== "style" &&
      propName !== "paddingRight" &&
      propName !== "paddingLeft" &&
      propName !== "paddingTop" &&
      propName !== "paddingBottom" &&
      propName !== "sx"
    );
  },
})<BadgeProps>((props) => {
  const { variant = "primary", color, backgroundColor, style, paddingLeft, paddingRight } = props;
  const variantConfig = variantDictionary[variant];

  return {
    display: "inline-flex",
    borderRadius: "100px",
    color: color ?? variantConfig?.color ?? variantDictionary.primary.color,
    backgroundColor:
      backgroundColor ??
      variantConfig?.backgroundColor ??
      variantDictionary.primary.backgroundColor,
    paddingRight: paddingLeft ?? "4px",
    paddingLeft: paddingRight ?? "4px",
    paddingTop: props.paddingTop ?? "2px",
    paddingBottom: props.paddingBottom ?? "2px",
    minWidth: "16px",
    minHeight: "16px",
    alignItems: "center",
    justifyContent: "center",

    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "11px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
    ...style,
  };
});
